<template>
  <div
    class="chat_correspondence__user d-flex gap-5"
  >
    <ChatAvatar
      v-if="chatItem.type !== 'PERSONAL' && !currentUserMessages"
      :src="findUserById && findUserById.photo"
      :text="findUserById && findUserById.first_name + ' ' + findUserById.last_name"
      :size="avatarSize"
      class="chat_correspondence__user__img unselectable"
    />
    <div class="chat_correspondence__user__messages d-flex flex-column gap-1 w-100">
      <ChatCorrespondenceMessage
        v-for="(message, messageKey) in item.messages"
        :key="'chat_' + $route.params.id + '__id_' + message.id"
        :messageKey="messageKey"
        :identity="'chat_' + $route.params.id + '__id_' + message.id"
        :message="message"
        :chatItem="chatItem"
        @contextmenu="showContextMenu($event, message)"
        :findUserById="findUserById"
        :observer="observer"
        :onFindUserById="onFindUserById"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatAvatar from 'components/chat/ChatAvatar'
import ChatCorrespondenceMessage from 'components/chat/correspondence/ChatCorrespondenceMessage'


export default {
  name: 'ChatСorrespondenceUser',
  components: {
    ChatAvatar,
    ChatCorrespondenceMessage,
  },
  props: {
    item: { type: Object },
    chatItem: Object,
    onFindUserById: Function,
    observer: IntersectionObserver,
  },
  data() {
    return { 
      avatarSize: 75,
    }
  },
  computed: {
    ...mapGetters('user', ['userData']),
    currentUserMessages() {
      return this.item.senderId === this.userData.id
    },
    messagesFormated() {
      let result = []
      const messages = this.chatItem.messages
      for (let messKey in messages) {
        let data = {
          senderId: messages[messKey].senderId,
          messages: [messages[messKey]],
          key: messKey,
        }
        let findResult = result.find((i) => i.key == messKey - 1)
        if (findResult && findResult.senderId === messages[messKey].senderId) {
          findResult.messages.push(messages[messKey])
          findResult.key = messKey
        } else result.push(data)
      }
      return result
    },
    findUserById() {
      return this.onFindUserById({ userId: this.item.senderId })
    },
  },
  methods: {
    showContextMenu(contextmenu, targetObj) {
      // console.log('showContextMenu', { contextmenu, targetObj })
      this.$emit('context', { contextmenu, targetObj })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat_correspondence__user {
  &__img {
    align-self: flex-end;
    position: -webkit-sticky; /* Safari */
    position: sticky;
    bottom: 10px;
  }
}
</style>
